import script from "./BinRestoreModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BinRestoreModal.vue?vue&type=script&setup=true&lang=js"

import "./BinRestoreModal.vue?vue&type=style&index=0&id=ac6b0f08&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac6b0f08"]])

export default __exports__